import React, { FC } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { NotificationsLocales } from '../../../../locales/locales.interfaces';
import { MessageType } from '../Notifications';
import style from './Toast.module.scss';

interface ToastProps {
  translationKey: keyof NotificationsLocales;
  type: keyof MessageType;
}

export const Toast: FC<ToastProps> = ({ translationKey, type }) => {
  const { t } = useTranslation<NotificationsLocales>('notifications');

  return <div className={style.toast}><span className={style[type]}>{t(translationKey)}</span></div>;
};
